import {
  FacebookProvider,
  Login,
  LoginStatus,
  useFacebook,
} from "react-facebook";
import { notification } from "antd";
import { imageURL } from "../../../constants/constants";

const APP_ID = process.env.REACT_APP_FACEBOOK_DEVELOPERS_APP_ID;

const PROFILE_FIELDS = ["name", "email", "picture"];

function FacebookLoginInner({
  btnText,
  onFinish,
  notify,
  mode = "login",
  shareUrl,
  showIconOnly = false,
  iconClass = "fa fa-facebook",
}) {
  const { api: fbApi, loading: sdkLoading, error: initError } = useFacebook();

  /** Load profile with explicit access_token so the SDK does not override the global session (avoids Meta console warning). */
  const handleSuccess = (response) => {
    (async () => {
      try {
        if (
          response.status !== LoginStatus.CONNECTED ||
          !response.authResponse ||
          !fbApi
        ) {
          return;
        }
        const { accessToken, userID } = response.authResponse;
        const profile = await fbApi.api("/me", "get", {
          fields: PROFILE_FIELDS.join(","),
          access_token: accessToken,
        });
        onFinish({
          email: profile.email,
          userID,
          name: profile.name,
        });
      } catch (e) {
        notify(e?.message || "Facebook profile fetch failed");
      }
    })();
  };

  const handleShare = async () => {
    try {
      if (!fbApi) return;

      await fbApi.ui({
        method: "share",
        href: shareUrl || window.location.href,
      });

      onFinish?.({ success: true });
    } catch (e) {
      notify("Facebook share failed");
    }
  };

  const handleError = (error) => {
    console.error("Facebook login error", error);
    notify("Facebook login failed");
  };

  return (
    <>
      {initError ? (
        <p className="text-danger small mb-2" role="alert">
          {initError.message}
        </p>
      ) : null}
      {/* 🔥 SWITCH BASED ON MODE */}
      {mode === "login" ? (
        <Login
          scope={["public_profile", "email"]}
          disabled={!fbApi || sdkLoading}
          onSuccess={handleSuccess}
          onError={handleError}
        >
          {({ onClick, loading, isDisabled }) => (
            <div className="btn-wrper mt-3">
              <button
                onClick={onClick}
                disabled={isDisabled}
                className="btn btn-primary bg"
              >
                {loading ? "Connecting..." : btnText}
              </button>
              <span className="btn-icon">
                <img src={`${imageURL}fb-icon.png`} alt="" />
              </span>
            </div>
          )}
        </Login>
      ) : (
        <div>
          {/* <button
            onClick={handleShare}
            disabled={!fbApi || sdkLoading}
            // className="btn btn-primary bg d-flex align-items-center gap-2"
          > */}
          {/* ICON */}
          {showIconOnly || !btnText ? (
            <i
              className={iconClass || "fa fa-facebook"}
              onClick={handleShare}
            ></i>
          ) : (
            <>
              <i className={iconClass || "fa fa-facebook"}></i>
              <span>{btnText}</span>
            </>
          )}
          {/* </button> */}
        </div>
      )}
    </>
  );
}

const FacebookLoginButton = (props) => {
  const notify = (message) => {
    notification.error({
      message: message,
      placement: "topRight",
    });
  };

  if (!APP_ID) {
    return (
      <p className="text-muted small mb-0">
        Facebook sign-in is not configured (missing App ID).
      </p>
    );
  }

  return (
    <FacebookProvider appId={APP_ID}>
      <FacebookLoginInner {...props} notify={notify} />
    </FacebookProvider>
  );
};

export default FacebookLoginButton;
